// import components
import { styled, Box } from '@mui/material';

export const StyledYearClosureProgressBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: theme.spacing(88)
}));

export const StyledYearCloseTitleBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(30),
  margin: theme.spacing(0, 1)
}));

export const StyledLinearProgressBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(20),
  marginRight: theme.spacing(1)
}));

export const StyledCalculatedProgressBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(12.5),
  color: theme.palette.error.main
}));

export const StyledErrorBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(12.5)
}));
